import { blue } from "@ant-design/colors";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import {
  NotificationLogo,
  NotificationMessage,
} from "@lib/components/PageComponents/Notification";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { TableColumnsProps } from "@lib/types/General";
import { Notification, NotificationEvents } from "@lib/types/Notification";
import { Typography, Badge } from "antd";
import { ColumnsType } from "antd/es/table";
import { FormattedMessage } from "react-intl";

type Props<T> = TableColumnsProps<T> & {
  handleClick: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    notification?: Notification,
  ) => void;
};

const getColumns = <T extends Notification>(
  props: Props<T>,
): ColumnsType<T> => {
  const { messages, handleClick } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.event",
      dataIndex: "event",
      width: "150px",
      render: (value, record) => {
        return (
          <StyledFlex>
            <NotificationLogo notification={record} size="small" onlyIcon />
            <Typography.Text style={{ marginLeft: "10px" }} ellipsis>
              <FormattedMessage id={`notification.name.${record?.event}`} />
            </Typography.Text>
          </StyledFlex>
        );
      },
      filterType: "dropdown",
      filters: Object.values(NotificationEvents).map((item) => ({
        text: messages[`notification.name.${item}`] || item,
        value: item,
      })),
    },

    {
      title: "common.notification",
      dataIndex: "notification",
      width: "500px",
      dontSort: true,
      render: (value, record) => {
        return (
          <StyledFlex>
            <NotificationLogo notification={record} size="small" />
            <Typography.Text style={{ marginLeft: "10px" }}>
              <NotificationMessage notification={record} />
            </Typography.Text>
          </StyledFlex>
        );
      },
    },

    {
      title: "common.createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "80px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <Badge dot={!record?.isResolved} color={blue[4]} size="small">
            <ActionButton
              type="detail"
              onClick={(e) => handleClick(e, record)}
              noLabel
            />
          </Badge>
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
